import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Component, HostBinding, ElementRef, Inject, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinOpenChange, FadvBaseComponent, Forward, openChangeInput, openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/tooltip/tooltip';

class FadvTooltipContentComponent {
    constructor() {
        this.slotName = 'content';
    }
}
FadvTooltipContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTooltipContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FadvTooltipContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvTooltipContentComponent, selector: "fadv-tooltip-content", host: { properties: { "slot": "this.slotName" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTooltipContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-tooltip-content',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvTooltipComponent extends mixinOpenChange(FadvBaseComponent) {
    constructor(el) {
        super(el);
        /* The content of the tooltip. */
        this.content = '';
        /* The preferred placement of the tooltip, but actual placement may vary to keep it inside of the viewport. */
        this.placement = 'top';
        /* When disabled, the tooltip does not show when triggered. */
        this.disabled = false;
        /* The distance in pixels from which to offset away from the target of the tooltip. */
        this.distance = 10;
        /* The distance in pixels from which to offset the tooltip along its target. */
        this.skidding = 0;
        /* Controls the way the tooltip is activated. Possible options are click, hover, focus, and manual.
        Supports multiple options by separating them with a space. */
        this.trigger = 'hover focus';
    }
}
FadvTooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTooltipComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvTooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvTooltipComponent, selector: "fadv-tooltip", inputs: { open: "open", content: "content", placement: "placement", disabled: "disabled", distance: "distance", skidding: "skidding", trigger: "trigger", variant: "variant", hoist: "hoist" }, outputs: { openChange: "openChange", shown: "shown", hidden: "hidden" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvTooltipComponent.prototype, "content", void 0);
__decorate([
    Forward()
], FadvTooltipComponent.prototype, "placement", void 0);
__decorate([
    Forward()
], FadvTooltipComponent.prototype, "disabled", void 0);
__decorate([
    Forward()
], FadvTooltipComponent.prototype, "distance", void 0);
__decorate([
    Forward()
], FadvTooltipComponent.prototype, "skidding", void 0);
__decorate([
    Forward()
], FadvTooltipComponent.prototype, "trigger", void 0);
__decorate([
    Forward()
], FadvTooltipComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvTooltipComponent.prototype, "hoist", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTooltipComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-tooltip',
                    template: '<ng-content></ng-content>',
                    inputs: [openChangeInput],
                    outputs: [openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { content: [{
                type: Input
            }], placement: [{
                type: Input
            }], disabled: [{
                type: Input
            }], distance: [{
                type: Input
            }], skidding: [{
                type: Input
            }], trigger: [{
                type: Input
            }], variant: [{
                type: Input
            }], hoist: [{
                type: Input
            }] } });

class FadvTooltipModule {
}
FadvTooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvTooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvTooltipModule, declarations: [FadvTooltipComponent, FadvTooltipContentComponent], imports: [FadvCommonModule], exports: [FadvTooltipComponent, FadvTooltipContentComponent] });
FadvTooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTooltipModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvTooltipComponent, FadvTooltipContentComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvTooltipComponent, FadvTooltipContentComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvTooltipComponent, FadvTooltipContentComponent, FadvTooltipModule };
